import { useState } from 'react';

export default function SexForm() {
    const [intensity, setIntensity] = useState('');
    const [type, setType] = useState('');
    const [withHandy, setWithHandy] = useState(false);
    const [withToy, setWithToy] = useState(false);
    const [partner, setPartner] = useState('');
    const [timestamp, setTimestamp] = useState('');

    function handleIntensityChange(e) {
        setIntensity(e.target.value);
    }

    function handleTypeChange(e) {
        setType(e.target.value);
    }

    function handleWithHandyChange(e) {
        setWithHandy(e.target.checked);
    }

    function handleWithToyChange(e) {
        setWithToy(e.target.checked);
    }

    function handlePartnerChange(e) {
        setPartner(e.target.value);
    }

    function handleTimestampChange(e) {
        setTimestamp(e.target.value);
    }

    async function handleSubmit() {
        const formTimestamp = timestamp ? new Date(parseInt(timestamp)).getTime() : Date.now();
        const req = {
            method: 'POST',
            body: JSON.stringify({
                sex: parseInt(intensity),
                type,
                with_handy: withHandy.toString(),
                with_toy: withToy.toString(),
                ...(partner ? { partner } : {}),
                timestamp: formTimestamp,
            }),
            headers: {
                'Content-Type': 'application/json',
            },
        };
        await fetch('https://life.pmusgrave.dev/sex', req)
            .catch((err) => {
                console.log(err.message);
            });
        setIntensity('');
        setType('');
        setWithHandy(false);
        setWithToy(false);
        setPartner('');
        setTimestamp('');
    }

    return (
        <div className="form-container">
            <h2>Sex Form</h2>
            <form onSubmit={e => e.preventDefault()}>
                <div className="form-group">
                    <label htmlFor="intensity">Intensity (0-100):</label>
                    <input
                        id="intensity"
                        type="number"
                        min="0"
                        max="100"
                        value={intensity}
                        onChange={handleIntensityChange}
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="type">Type:</label>
                    <select
                        id="type"
                        value={type}
                        onChange={handleTypeChange}
                        required
                    >
                        <option value="">Select a type</option>
                        <option value="SOLO">SOLO</option>
                        <option value="AR_PASSTHROUGH">AR_PASSTHROUGH</option>
                        <option value="VR">VR</option>
                        <option value="MIXED_AR_VR">MIXED_AR_VR</option>
                        <option value="PORN">PORN</option>
                        <option value="SEX">SEX</option>
                    </select>
                </div>
                <div className="form-group checkbox-group">
                    <label>
                        <input
                            type="checkbox"
                            checked={withHandy}
                            onChange={handleWithHandyChange}
                        />
                        With Handy
                    </label>
                </div>
                <div className="form-group checkbox-group">
                    <label>
                        <input
                            type="checkbox"
                            checked={withToy}
                            onChange={handleWithToyChange}
                        />
                        With Toy
                    </label>
                </div>
                <div className="form-group">
                    <label htmlFor="partner">Partner (optional):</label>
                    <input
                        id="partner"
                        type="text"
                        value={partner}
                        onChange={handlePartnerChange}
                        placeholder="Partner name"
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="timestamp">Timestamp (optional):</label>
                    <input
                        id="timestamp"
                        type="number"
                        value={timestamp}
                        onChange={handleTimestampChange}
                        placeholder="Unix timestamp"
                    />
                </div>
                <button 
                    onClick={handleSubmit}
                    className="submit-button"
                >
                    Submit
                </button>
            </form>
        </div>
    );
} 
